.root {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  width: 36px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: var(--line);
  cursor: pointer;
}

.root[data-state='checked'] {
  background: var(--st-in);
}

.root:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/*
 * ⚠️ `#fff` ЗДЕСЬ ОСТАЁТСЯ ОСОЗНАННО — и это единственный литерал кита, у которого есть право.
 * Он объявлен поимённо в `tools/contrast.mjs` (`ЛИТЕРАЛЫ_ПО_ДЕЛУ`), там же полный замер. Кратко:
 *
 * Бегунок лежит на ДВУХ дорожках сразу — `--line` (выкл) и `--st-in` (вкл), — а они стоят на
 * противоположных краях светлоты в КАЖДОЙ теме (светлая 87% / 54%, тёмная 31% / 72%). Поэтому ни
 * один токен палитры не берёт 3 : 1 против обеих; худшее из четырёх сочетаний:
 *
 *     #fff 1.48   --ink 2.09   --panel 1.28   --on-accent 1.38   --bg 1.38   --sunk 1.29
 *
 * «Починка» токеном сделала бы ХУЖЕ: `--panel`/`--on-accent` — тёмные в тёмной теме, и бегунок на
 * выключенной дорожке утонул бы (сейчас белый даёт там 13.19, они дают 1.28). Не переставляй.
 *
 * Состояние тумблера несут ПОЛОЖЕНИЕ бегунка и цвет дорожки, а не контраст самого бегунка; макет
 * отделяет его тенью (`box-shadow: 0 1px 3px`, prototype:1106). Настоящее решение — токен «краска
 * поверх любой дорожки», а палитра это зона проектировщика (шапка `tokens.css`): ему и передано.
 */
.thumb {
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: #fff;
  transform: translateX(2px);
  transition: transform 0.16s var(--ease);
}

.thumb[data-state='checked'] {
  transform: translateX(18px);
}
